import { render, staticRenderFns } from "./AddMultipleOptions.vue?vue&type=template&id=2287f48e&scoped=true&"
import script from "./AddMultipleOptions.vue?vue&type=script&lang=js&"
export * from "./AddMultipleOptions.vue?vue&type=script&lang=js&"
import style0 from "./AddMultipleOptions.vue?vue&type=style&index=0&id=2287f48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287f48e",
  null
  
)

export default component.exports